const BASE =
  "https://s3.us-east-1.amazonaws.com/assets.sbnation.com/csk/uploads/verge-features/data-centers/data-centers-loudoun";

/** Bust browser/S3 caches after replacing lede media at the same keys. */
const V = "20261026c";

function loudounAsset(path: string): string {
  return `${BASE}/${path}?v=${V}`;
}

/** Lede media on the Loudoun feature S3 prefix. */
export const ledeAssets = {
  hedDesktop: `${BASE}/hed-desktop.svg`,
  hedMobile: `${BASE}/hed-mobile.svg`,
  videoDesktop: loudounAsset("lede-desktop.mp4"),
  videoMobile: loudounAsset("lede-mobile.mp4"),
  videoPoster: loudounAsset("lede-poster.jpg"),
  videoPosterMobile: loudounAsset("lede-poster-mobile.jpg"),
} as const;
